/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

//redux imports

// components imports
import AccountName from "../../../../../components/_utils/AccountCreationComponents/AccountName";
import ContactDetails from "../../../../../components/_utils/AccountCreationComponents/ContactDetails";
import CommonLayout from "../../../../../components/_utils/CommonLayout";
import SmallPopup from "../../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../../components/_utils/CommonSteppers/PrimaryStepper";
import TopNavComponent from "../../../../../components/_utils/CommonTopNav/TopNavComponent";
import LinkEntityCard from "../../../../../components/_utils/LinkEntityCard";
import {
  editReimbursementAccount,
  resetEditReimbursementAccount,
  viewAccountDetailR,
} from "../../../../../redux/features/accounts/ReimburseAccount";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import Validation from "../../../../../utils/validation";

const ReimbursementEditContact = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [customErrors, setCustomErrors] = useState({});
  const [selectedValue, setSelectedValue] = useState("");
  const [emailValidation, setEmailValidation] = useState(false);
  const [nextButtonDisabled, setNextButtonDisabled] = useState(true);
  const [openEditContactPop, setOpenEditContactPop] = useState(false);
  const [accountNameValidation, setAccountNameValidation] = useState(true);
  const [contactNumberValidation, setContactNumberValidation] = useState(false);
  const [payload, setPayload] = useState({
    contact_no: "",
    email_id: "",
    account_name: "",
    legalName: "",
    linked_user_id: "",
    userName: "",
    userId: "",
  });

  const {
    viewAccountDetailData,
    viewAccountDetailLoading,
    reimbursementAccountEditData,
    reimbursementAccountEditLoading,
    reimbursementAccountEditError,
  } = useSelector((state) => state.ReimburseAccount);

  const { services, isLoading } = useSelector((state) => state.refreshToken);
  useEffect(() => {
    const fetchContactData = async () => {
      let response = await dispatch(viewAccountDetailR({ id: id }));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    };
    fetchContactData();
  }, [dispatch, id, navigate]);

  const handleBack = () => {
    if (!nextButtonDisabled) {
      setOpenEditContactPop(true);
    } else {
      navigate(GlobalConfiguration?.navigate_back);
    }
  };

  const handleRadioBtn = (event) => {
    setSelectedValue(event.target.value);
    handleUpdateLegalName();
  };

  const handleDivBtn = (value) => {
    setSelectedValue(value);
    if (value === "legalname") {
      handleUpdateLegalName("legalname");
    } else if (value === "username") {
      handleUpdateLegalName("username");
    } else {
      handleUpdateLegalName("customname");
    }
  };

  useEffect(() => {
    if (!viewAccountDetailLoading && viewAccountDetailData?.status === true) {
      const reimbursementData =
        viewAccountDetailData?.reimbursement_accounts[0];

      if (reimbursementData) {
        setPayload((prevPayload) => ({
          ...prevPayload,
          contact_no: reimbursementData?.contact_no,
          email_id: reimbursementData?.email_id,
          account_name: reimbursementData?.name,
          legalName: reimbursementData?.pan_legal_name,
          linked_user_id: reimbursementData?.linked_user_id ?? "",
          userName: reimbursementData?.reimbursement_user_full_name ?? "",
          userId: reimbursementData?.reimbursement_identifier ?? "",
        }));
      }
      const accountNameSource = resolveAccountNameSource(reimbursementData);
      setSelectedValue(accountNameSource);
      // setSe(accountNameSource);
    }
  }, [viewAccountDetailData, viewAccountDetailLoading, dispatch]);

  const emailRegex = Validation.emailRegex;
  useEffect(() => {
    setContactNumberValidation(
      Validation.allowedContactNum(payload.contact_no),
    );
    setEmailValidation(emailRegex.test(payload.email_id));
  }, [payload.contact_no, payload.email_id]);

  const modifyValue = (type, value) => {
    if (type === "name") {
      return value?.replace(/(\w)(\w*)/g, function (g1, g2) {
        return g1.toUpperCase() + g2.toLowerCase();
      });
    } else if (type === "gstin") {
      return value?.toUpperCase();
    } else if (type === "account_name") {
      return value;
    } else {
      return value.trim();
    }
  };

  const allowedValue = (name, value) => {
    if (name === "contact_no") return Validation.allowedContactNum(value);
    if (name === "email_id") return Validation.allowedEmail(value);

    return true;
  };

  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };
    if (name === "email_id")
      errors = Validation.validateEmail(name, value, errors);
    if (name === "contact_no")
      errors = Validation.validateContactNum(name, value, errors);
    if (name === "account_name")
      errors = Validation.validateAccountName(name, value, errors);
    setCustomErrors(errors);
  };

  const checkAllValidations = () => {
    return contactNumberValidation && emailValidation;
  };

  const handleUpdateLegalName = (value) => {
    const reimbursementData =
      viewAccountDetailData?.reimbursement_accounts?.[0];

    setPayload((prevPayload) => {
      if (value === "legalname") {
        return {
          ...prevPayload,
          account_name: reimbursementData?.pan_legal_name || "",
        };
      }
      if (value === "username") {
        return {
          ...prevPayload,
          account_name: payload.userName || "",
        };
      }
      if (value === "customname") {
        const keepCurrent =
          prevPayload.account_name &&
          prevPayload.account_name.trim().length >
            GlobalConfiguration.lengthCheckZero &&
          prevPayload.account_name.trim().toLowerCase() !==
            (reimbursementData?.pan_legal_name || "").trim().toLowerCase() &&
          prevPayload.account_name.trim().toLowerCase() !==
            (payload.userName || "").trim().toLowerCase();
        return {
          ...prevPayload,
          account_name: keepCurrent
            ? prevPayload.account_name
            : reimbursementData?.name || payload.userName || "",
        };
      }

      return prevPayload;
    });
  };

  const normalizeAccountName = (name) => (name || "").trim().toLowerCase();

  const resolveAccountNameSource = (accountData) => {
    const accountName = normalizeAccountName(accountData?.name);
    const legalName = normalizeAccountName(accountData?.pan_legal_name);
    const linkedUserName = normalizeAccountName(
      accountData?.reimbursement_user_full_name,
    );

    if (accountName && accountName === legalName) {
      return "legalname";
    }
    if (accountName && linkedUserName && accountName === linkedUserName) {
      return "username";
    }
    return "customname";
  };
  useEffect(() => {
    if (!viewAccountDetailLoading && viewAccountDetailData?.status === true) {
      const reimbursementData =
        viewAccountDetailData?.reimbursement_accounts[0];
      const linkedUserChanged =
        String(reimbursementData?.linked_user_id ?? "") !==
        String(payload?.linked_user_id ?? "");
      const contactEmailChanged =
        reimbursementData?.contact_no !== payload?.contact_no ||
        reimbursementData?.email_id !== payload?.email_id?.toLowerCase();
      const nameChanged =
        reimbursementData?.name?.trim() !== payload?.account_name?.trim() &&
        payload?.account_name?.length !== GlobalConfiguration.lengthCheckZero;

      const hasChanges =
        linkedUserChanged || contactEmailChanged || nameChanged;

      if (hasChanges) {
        if ((linkedUserChanged && !contactEmailChanged) || nameChanged) {
          setNextButtonDisabled(false);
        } else if (
          checkAllValidations() &&
          payload.email_id?.length !== GlobalConfiguration.lengthCheckZero &&
          payload.contact_no?.length !== GlobalConfiguration.lengthCheckZero &&
          payload.account_name.trim().length >
            GlobalConfiguration.lengthCheckZero
        ) {
          setNextButtonDisabled(false);
        } else {
          setNextButtonDisabled(true);
        }
      } else {
        setNextButtonDisabled(true);
      }
    }
  }, [
    payload.account_name,
    payload.contact_no,
    payload.email_id,
    payload.linked_user_id,
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue = modifyValue(
      name,
      name !== "account_name" ? value.replace(/[^a-zA-Z0-9@.]/g, "") : value,
    );

    if (allowedValue(name, value)) {
      validateAndRecordError(name, newValue);
      setPayload((prevState) => ({
        ...prevState,
        [name]: newValue,
      }));

      if (
        value.trim() === "" &&
        value.length === GlobalConfiguration.lengthCheckOne
      ) {
        return;
      }
      if (name === "contact_no") {
        if (
          name === "contact_no" &&
          (newValue.length === GlobalConfiguration.lengthCheckZero ||
            newValue.length < GlobalConfiguration.panLength)
        ) {
          setContactNumberValidation(false);
        } else {
          setContactNumberValidation(true);
        }
      }
      if (name === "email_id") {
        if (
          name === "email_id" &&
          (newValue.length === GlobalConfiguration.lengthCheckZero ||
            !emailRegex.test(newValue))
        ) {
          setEmailValidation(false);
        } else {
          setEmailValidation(true);
        }
      }
      if (name === "account_name") {
        if (value.trim().length > GlobalConfiguration?.lengthCheckZero) {
          if (newValue === payload?.legalName) {
            setSelectedValue("legalname");
          } else if (value === payload?.userName) {
            setSelectedValue("username");
          } else {
            setSelectedValue("customname");
          }
          setAccountNameValidation(true);
        }
      }
    }
  };

  useEffect(() => {
    if (customErrors["contact_no"]) setContactNumberValidation(false);
    if (
      !customErrors["contact_no"] &&
      payload.contact_no?.length === GlobalConfiguration.panLength
    )
      setContactNumberValidation(true);
    if (customErrors["email_id"]) setEmailValidation(false);
    if (
      !customErrors["email_id"] &&
      payload.email_id?.length > GlobalConfiguration.lengthCheckZero &&
      emailRegex.test(payload.email_id)
    )
      setEmailValidation(true);
    if (customErrors["account_name"]) setAccountNameValidation(false);
    if (
      !customErrors["account_name"] &&
      payload.account_name.length > GlobalConfiguration.lengthCheckZero
    )
      setAccountNameValidation(true);
  }, [customErrors]);

  useEffect(() => {
    if (reimbursementAccountEditData?.status === true) {
      const reimbursementData =
        viewAccountDetailData?.reimbursement_accounts?.[0];
      const updatedFields = [];
      if (reimbursementData?.contact_no !== payload?.contact_no) {
        updatedFields.push("contact_no");
      }
      if (
        (reimbursementData?.email_id || "").toLowerCase().trim() !==
        (payload?.email_id || "").toLowerCase().trim()
      ) {
        updatedFields.push("email_id");
      }
      if (
        (reimbursementData?.name || "").trim() !==
        (payload?.account_name || "").trim()
      ) {
        updatedFields.push("account_name");
      }
      if (
        String(reimbursementData?.linked_user_id ?? "") !==
        String(payload?.linked_user_id ?? "")
      ) {
        updatedFields.push("linked_user");
      }
      navigate(
        `/reimbursement_account_dashboard/reimbursement_account_view_all/view_details/Contact_edit_success/${id}`,
        {
          state: {
            updatedFields:
              updatedFields.length > GlobalConfiguration.lengthCheckZero
                ? updatedFields
                : ["contact_no", "email_id", "account_name", "linked_user"],
          },

          replace: true,
        },
      );
      dispatch(resetEditReimbursementAccount());
    }
  }, [reimbursementAccountEditData]);

  useEffect(() => {
    if (!isLoading && services != null) {
      if (services?.includes("RUAccount") || services?.includes("Admin")) {
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "RUAccount" },
        });
      }
    }
  }, [services, isLoading]);

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Update",
      stepperText: "Name, user and contact details",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextIsEnabled: !nextButtonDisabled,
      nextHoverOption: "black",
      nextIsLoading: reimbursementAccountEditLoading,
      nextLoaderNeeded: true,
    },
  ];

  const handleUpdateAccount2 = () => {
    dispatch(
      editReimbursementAccount({
        id: id,
        email: payload?.email_id?.toLowerCase(),
        contact_no: payload?.contact_no,
        name: payload?.account_name,
        reimbursement_account: true,
        navigate,
        linked_user_id: payload?.linked_user_id || null,
      }),
    );
  };

  const handleConfirm = () => {
    navigate(
      `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
    );
  };

  const handleEnterKeyPress = useCallback(
    (e) => {
      if (e.key === "Enter" && !nextButtonDisabled) {
        handleUpdateAccount2();
      }
    },
    [nextButtonDisabled, handleUpdateAccount2],
  );

  useEffect(() => {
    document.addEventListener("keydown", handleEnterKeyPress);

    return () => {
      document.removeEventListener("keydown", handleEnterKeyPress);
    };
  }, [handleEnterKeyPress]);
  useEffect(() => {
    if (reimbursementAccountEditError) {
      setNextButtonDisabled(true);
    }
  }, [reimbursementAccountEditError]);

  return (
    <>
      <div className=" bg-primary-bg flex overflow-y-hidden flex-col h-full-height">
        <div className="h-navbar-breadcrumb-height hidden Qmd:block"></div>
        <div
          className="max-w-tab-width-normal  w-full flex flex-col justify-start items-center mx-auto my-margin-base Qsmd:h-stepper-moble-height"
          style={{
            overflow: !nextButtonDisabled && openEditContactPop ? "hidden" : "",
          }}
        >
          {!nextButtonDisabled && openEditContactPop && (
            <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
              <SmallPopup
                headerTitle={"Confirm leaving this page?"}
                headerFontWeight="semibold"
                headerFontColor="text-primary"
                textSize="font-md"
                subtext="Leaving this page will not update the changes made."
                btnOneText="Stay"
                btnOneBtnType="button"
                btnOneEnabledBgColor="transparent"
                btnOneHandleFunction={() => setOpenEditContactPop(false)}
                btnOneOutLineColor="var(--text-primary)"
                btnOneEnabledTextColor="var(--text-primary)"
                btnOneIsDisabled={false}
                btnOneHoverOption="white"
                btnTwoText="Leave"
                btnTwoBtnType="button"
                btnTwoHandleFunction={handleConfirm}
                btnTwoEnabledBgColor="var(--negative-act)"
                btnTwoEnabledTextColor="var(--text-primary)"
                btnTwoIsDisabled={false}
                btnTwoHoverOption="black"
              />
            </div>
          )}
          <div className="min-h-stepper-height Qsmd:relative hidden h-auto  justify-center items-end bottom-bottom-base Qsmd:flex fixed Qmd:top-top-base left-left-base w-width-full z-z-index-header">
            <PrimaryStepper
              activeStep={0}
              handleForwardAction={handleUpdateAccount2}
              handleBackwardAction={handleBack}
              dataArray={dataArray}
            />
          </div>
          <div className="block Qmd:hidden w-full">
            <TopNavComponent
              isFormattingNotRequired
              topNavSubText="User and contact details"
              topNavHeader={"Reimbursement Account"}
              topNavCtaBtn1Props={{
                btnText: "Update",
                btnType: "button",
                inActiveVariantNeeded: true,
                enabledBgColor: "var(--positive-act)",
                enabledTextColor: "var(--text-primary)",
                disabledBgColor: "var(--text-disabled)",
                isDisabled: nextButtonDisabled,
                handleFunction: !nextButtonDisabled
                  ? handleUpdateAccount2
                  : () => {},
              }}
            />
          </div>
          {/* <div className="h-navbar-height block Qmd:hidden"></div> */}
        </div>

        <div className="h-full-height max-w-tab-width-normal mx-auto w-full px-padding-md Qlg:px-padding-base overflow-y-auto pt-padding-md flex-1 pb-[var(--stepper-moble-height)]">
          <div>
            <CommonLayout>
              <AccountName
                handleChange={handleChange}
                accountNameValidation={accountNameValidation}
                accountName={payload?.account_name}
                selectedValue={selectedValue}
                handleDivBtn={handleDivBtn}
                handleRadioBtn={handleRadioBtn}
                selectedRadioValue={selectedValue}
                legalName={payload?.legalName}
                type={"user"}
                userName={payload?.userName}
                placeHolder={"Account name"}
              />

              <div className="flex flex-col relative rounded-border-radius-md w-full mb-margin-md  gap-gap-md">
                <LinkEntityCard
                  payload={payload}
                  setPayload={setPayload}
                  selectedValue={selectedValue}
                  headerTitle="User view all"
                  redirectPath="/settings/user_view_all"
                  title="User"
                  description="Linked user will be able to create reimbursement requests."
                  buttonText="Link user"
                  nameKey="userName"
                  idKey="userId"
                  nameLabel="Username"
                  idLabel="User ID"
                  isOptional={true}
                />
                <ContactDetails
                  handleChange={handleChange}
                  contactNumberValidation={contactNumberValidation}
                  emailValidation={emailValidation}
                  contactNumber={payload.contact_no}
                  emailId={payload.email_id}
                  selectedValue={selectedValue}
                />
              </div>
            </CommonLayout>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReimbursementEditContact;
